module.exports = __webpack_public_path__ + "static/img/new_tag.dd9a6a30.png";